export default __webpack_public_path__ + "static/media/3D-printing.558d5735.jpg";